




import IStyleDto from "./StyleDto.if";
import mappings from "./StyleDto.map";
import IFontSizeUnitDto from "./FontSizeUnitDto.if";
import FontSizeUnitDto from "./FontSizeUnitDto";
import IMediumDto from "./MediumDto.if";
import MediumDto from "./MediumDto";
import IBackgroundMode from "./BackgroundModeDto.if";
import BackgroundMode from "./BackgroundModeDto";
import IFontFamilyDto from "./FontFamilyDto.if";
import FontFamilyDto from "./FontFamilyDto";
import IFontStyleDto from "./FontStyleDto.if";
import FontStyleDto from "./FontStyleDto";
import IFontAlignmentDto from "./FontAlignmentDto.if";
import FontAlignmentDto from "./FontAlignmentDto";
import ISiteDto from "./SiteDto.if";
import SiteDto from "./SiteDto";

import Transformers from './private/transformer';
import DBUtils from './private/db.util';
import { IModelSource } from "./private/db.if";

function _parent(this: IStyleDto, db: IModelSource): Promise<IStyleDto> {
    return DBUtils.loadStyleId<IStyleDto>(db, this.parentId, StyleDto);
}

function _site(this: IStyleDto, db: IModelSource): Promise<ISiteDto> {
    return DBUtils.loadSiteId<ISiteDto>(db, this.siteId, SiteDto);
}

function _foregroundImageMedium(this: IStyleDto, db: IModelSource): Promise<IMediumDto> {
    return DBUtils.loadMediumId<IMediumDto>(db, this.foregroundImageMediumId, MediumDto);
}

function _backgroundImageMedium(this: IStyleDto, db: IModelSource): Promise<IMediumDto> {
    return DBUtils.loadMediumId<IMediumDto>(db, this.backgroundImageMediumId, MediumDto);
}

function _menuImageMedium(this: IStyleDto, db: IModelSource): Promise<IMediumDto> {
    return DBUtils.loadMediumId<IMediumDto>(db, this.menuImageMediumId, MediumDto);
}

function _backgroundMode(this: IStyleDto, db: IModelSource): Promise<IBackgroundMode> {
    return DBUtils.loadBackgroundModeId<IBackgroundMode>(db, this.backgroundModeId, BackgroundMode);
}

function _primaryFontFamily(this: IStyleDto, db: IModelSource): Promise<IFontFamilyDto> {
    return DBUtils.loadFontFamilyId<IFontFamilyDto>(db, this.primaryFontFamilyId, FontFamilyDto);
}

function _primaryFontStyle(this: IStyleDto, db: IModelSource): Promise<IFontStyleDto> {
    return DBUtils.loadFontStyleId<IFontStyleDto>(db, this.primaryFontStyleId, FontStyleDto);
}

function _primaryFontSizeUnit(this: IStyleDto, db: IModelSource): Promise<IFontSizeUnitDto> {
    return DBUtils.loadFontSizeUnitId<IFontSizeUnitDto>(db, this.primaryFontSizeUnitId, FontSizeUnitDto);
}

function _primaryFontAlignment(this: IStyleDto, db: IModelSource): Promise<IFontAlignmentDto> {
    return DBUtils.loadFontAlignmentId<IFontAlignmentDto>(db, this.primaryFontAlignmentId, FontAlignmentDto);
}

function _secondaryFontFamily(this: IStyleDto, db: IModelSource): Promise<IFontFamilyDto> {
    return DBUtils.loadFontFamilyId<IFontFamilyDto>(db, this.secondaryFontFamilyId, FontFamilyDto);
}

function _secondaryFontStyle(this: IStyleDto, db: IModelSource): Promise<IFontStyleDto> {
    return DBUtils.loadFontStyleId<IFontStyleDto>(db, this.secondaryFontStyleId, FontStyleDto);
}

function _secondaryFontSizeUnit(this: IStyleDto, db: IModelSource): Promise<IFontSizeUnitDto> {
    return DBUtils.loadFontSizeUnitId<IFontSizeUnitDto>(db, this.secondaryFontSizeUnitId, FontSizeUnitDto);
}

function _secondaryFontAlignment(this: IStyleDto, db: IModelSource): Promise<IFontAlignmentDto> {
    return DBUtils.loadFontAlignmentId<IFontAlignmentDto>(db, this.secondaryFontAlignmentId, FontAlignmentDto);
}

function _tertiaryFontFamily(this: IStyleDto, db: IModelSource): Promise<IFontFamilyDto> {
    return DBUtils.loadFontFamilyId<IFontFamilyDto>(db, this.tertiaryFontFamilyId, FontFamilyDto);
}

function _tertiaryFontStyle(this: IStyleDto, db: IModelSource): Promise<IFontStyleDto> {
    return DBUtils.loadFontStyleId<IFontStyleDto>(db, this.tertiaryFontStyleId, FontStyleDto);
}

function _tertiaryFontSizeUnit(this: IStyleDto, db: IModelSource): Promise<IFontSizeUnitDto> {
    return DBUtils.loadFontSizeUnitId<IFontSizeUnitDto>(db, this.tertiaryFontSizeUnitId, FontSizeUnitDto);
}

function _tertiaryFontAlignment(this: IStyleDto, db: IModelSource): Promise<IFontAlignmentDto> {
    return DBUtils.loadFontAlignmentId<IFontAlignmentDto>(db, this.tertiaryFontAlignmentId, FontAlignmentDto);
}

function StyleDto(data: object) { 
    const obj = Transformers.create<IStyleDto>(mappings, data);

    /* addLinkables */
    obj.parent                      = _parent;
    obj.site                        = _site;
    obj.foregroundImageMedium       = _foregroundImageMedium;
    obj.backgroundImageMedium       = _backgroundImageMedium;
    obj.menuImageMedium             = _menuImageMedium;
    obj.backgroundMode              = _backgroundMode;

    obj.primaryFontFamily           = _primaryFontFamily;
    obj.primaryFontStyle            = _primaryFontStyle;
    obj.primaryFontSizeUnit         = _primaryFontSizeUnit;
    obj.primaryFontAlignment        = _primaryFontAlignment;

    obj.secondaryFontFamily         = _secondaryFontFamily;
    obj.secondaryFontStyle          = _secondaryFontStyle;
    obj.secondaryFontSizeUnit       = _secondaryFontSizeUnit;
    obj.secondaryFontAlignment      = _secondaryFontAlignment;

    obj.tertiaryFontFamily          = _tertiaryFontFamily;
    obj.tertiaryFontStyle           = _tertiaryFontStyle;
    obj.tertiaryFontSizeUnit        = _tertiaryFontSizeUnit;
    obj.tertiaryFontAlignment       = _tertiaryFontAlignment;

    return obj;
}

export default StyleDto

